/*
 * --------------------------------------------------------------------------- *
 * File: constants.js                                                          *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Tue Nov 01 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import Dashboard from "../bank/Dashboard";
import Collateral from "../bank/Collateral";
import CollateralSearch from "../bank/CollateralSearch";
import Customer from "../bank/Customer";
import Reports from "../bank/Reports";
import DataTypeList from "../config/datatypelist";
import EditType from "../config/edittype";

class Constants {
  static apiBaseUrl = "https://ep6138s08h.execute-api.ap-southeast-2.amazonaws.com/v1";
  static cloudFrontBaseUrl = "https://d10q50nu3buyp.cloudfront.net";
  static bank = "anz";
  static apiKey = "985f719564674cac95f92447c3706648d864b0fe00114c58a7c3a3bc991629e7";

  static title = "One Collateral";
  static SHOW_NOW_DASHBOARD = "DASHBOARD";
  static SHOW_NOW_CUSTOMERS = "CUSTOMERS";
  static SHOW_NOW_COLLATERALS = "COLLATERALS";
  static SHOW_NOW_EDIT_COLLATERAL = "EDIT_COLLATERAL";
  static SHOW_NOW_REPORTS = "REPORTS";
  static SHOW_NOW_DATA_TYPE_LIST = "DATA_TYPE_LIST";
  static SHOW_NOW_DATA_TYPE_EDIT = "DATA_TYPE_EDIT";

  static sideBarElements = [
    { title: "Dashboard", showNow: this.SHOW_NOW_DASHBOARD },
    { title: "Customers", showNow: this.SHOW_NOW_CUSTOMERS },
    { title: "Collateral List", showNow: this.SHOW_NOW_COLLATERALS },
    { title: "Collateral", showNow: this.SHOW_NOW_EDIT_COLLATERAL },
    { title: "Reports", showNow: this.SHOW_NOW_REPORTS },
    { title: "Configure DataTypes", showNow: this.SHOW_NOW_DATA_TYPE_LIST },
  ];

  static showNowComponent = (showNow) => {
    switch (showNow) {
      case Constants.SHOW_NOW_COLLATERALS:
        return <CollateralSearch />;
      case Constants.SHOW_NOW_CUSTOMERS:
        return <Customer />;
      case Constants.SHOW_NOW_EDIT_COLLATERAL:
        return <Collateral />;
      case Constants.SHOW_NOW_REPORTS:
        return <Reports />;
      case Constants.SHOW_NOW_DASHBOARD:
        return <Dashboard />;
      case Constants.SHOW_NOW_DATA_TYPE_LIST:
        return <DataTypeList />;
      case Constants.SHOW_NOW_DATA_TYPE_EDIT:
        return <EditType />;
      default:
        return <>Error!</>;
    }
  };

  static DATA_TYPE_NUMBER = "number";
  static DATA_TYPE_TEXT = "text";
  static DATA_TYPE_CHECKBOX = "boolean";
  static DATA_TYPE_DATE = "date";
  static DATA_TYPE_SELECT = "select";
  static DATA_TYPE_LIST = "list";
  static DATA_TYPE_PASSWORD = "password";
  static DATA_TYPE_ADDRESS = "address";
  static DATA_TYPE_CUSTOM_TYPES = {};

  static SHOW_EDIT_TYPE = "EDIT_TYPE";
  static SHOW_DATA_TYPE_LIST = "DATA_TYPE_LIST";
  static SHOW_LIST_COLLATERALS = "LIST_COLLATERALS";
  static SHOW_EDIT_COLLATERAL = "EDIT_COLLATERAL";
}
export default Constants;
